import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import DataTable from 'react-data-table-component';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { tokenVerification } from './Utils';


// An hour the chosen offset type does not use: greyed out so it reads as not editable.
const disabledHourInput = { backgroundColor: "#e9ecef", color: "#9aa0a6", cursor: "not-allowed" };

class JournalMilestone extends Component {
    constructor(props) {
        super(props);

        this.state = {
            startLoader: false,
            loadedData: [],
            disableAddButton: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit.svg',
            contentEditable: "false",
            hidden: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            pageNum: null,
            paginationValue: 10,
            mileStones: "",
            selectedMilestoneName: "",
            selectedMilestoneId: "",
            milestoneStart: "",
            milestoneEnd: "",
            offsetType: "SPECIFIC_TIME",
            hourOffset: "",
            minuteOffset: "",
            isLoading: true,
            noDataMessage: ""

        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
        this.userDetails = JSON.parse(localStorage.getItem("user_details"));
    }

    componentDidMount() {
        localStorage.setItem("active-tab-of-manage-admission", "episodes");
        this.fetchJournalMilestones();
    }

    fetchMileStones() {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/fetch-milestones",
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                treatmentId: this.props.location.state.treatmentId,
            },
            success: function (res) {
                if (res.success === true) {
                    if (res.result.length > 0) {
                        thisController.state.mileStones = res.result;
                        thisController.setState(thisController.state);
                    } else {
                        thisController.state.noDataMessage = "There is no milestones added for this treatment, Please add"
                        thisController.setState(thisController.state);
                    }

                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            },
        });
    }




    addEmptyRow = () => {

        console.log("Adding Empty Row");
        var thisController = this;
        if (thisController.state.mileStones == "") {
            console.log("Empty milestones");
            thisController.notifyEmptyTreatmentMilestones();
        } else {
            thisController.state.paginationValue = thisController.state.paginationValue + 5;
            if (thisController.state.pageNum != 0) {
                thisController.setState({ pageNum: 0 })
            }
            thisController.state.selectedMilestoneName = "";
            thisController.state.milestoneStart = "";
            thisController.state.milestoneEnd = "";
            // These were left at whatever the last edited row had, so a new row could open with
            // the offset fields disabled for no visible reason, or carry a stale offset into the save.
            thisController.state.offsetType = "SPECIFIC_TIME";
            thisController.state.hourOffset = "";
            thisController.state.minuteOffset = "";
            var row = {
                id: "",
                    milestoneName: "",
                    milestoneStart: "",
                    milestoneEnd: "",
                    offsetType: "SPECIFIC_TIME",
                    hourOffset: "",
                    minuteOffset: "",
            }
            var allData = [row, ...thisController.state.loadedData];
            thisController.state.loadedData = allData;
            thisController.state.editedId = "";
            thisController.state.disableAddButton = true;
            thisController.setState(thisController.state);
        }
    }



    notifyEpisodeAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
            content="" />&nbsp;&nbsp;Episode added successfully</b>, {
            position: "top-center",
        });
    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        }, { toastId: "empty1" });

    }

    notifyEmptyTreatmentMilestones() {
        // toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;There are no milestones currently defined for this treatment.  Milestones may be added using the treatment milestone button on the Engagement tab.</b>, {
            position: "top-center"
        }, { toastId: "nomilestone" });

    }

    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>{this.state.noDataMessage}</p>
        </div>
    );

    notifyImproperName() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid name</b>, {
            position: "top-center"
        });
    }
    notifyNoAgent() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;No Virtual agent for this treatment </b>, {
            position: "top-center"
        });
    }
    notifyFailedLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red",
        });
    }



    notifuEpisodeUpdated() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
            content="" />&nbsp;&nbsp;Episode details updated successfully</b>, {
            position: "top-center",
        });
    }

    notifyFailedToUpdate(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }



    makeCelledit(props, e) {
        this.markAsBeingEdited(props);
    }

    markAsBeingEdited(props) {
        this.state.editedId = props.id;
        this.state.selectedMilestoneId = props.milestoneId;
        this.state.selectedMilestoneName = props.milestoneName;
        this.state.milestoneEnd = props.milestoneEnd;
        this.state.milestoneStart = props.milestoneStart;
        this.state.offsetType = props.offsetType || "SPECIFIC_TIME";
        this.state.hourOffset = props.hourOffset == null ? "" : props.hourOffset;
        this.state.minuteOffset = props.minuteOffset == null ? "" : props.minuteOffset;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }




    openDeletePopUp = (props) => {

        confirmAlert({
            title: 'Confirm to Delete',
            message: `Are you sure you want to delete ${props.milestoneName} ?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.deleteJournalMilestone(props.id)
                },
                {
                    label: 'No',
                }
            ],
            overlayClassName: "confirmAlertStyle"
        });
    }


    // A row added with "+" but never saved only exists in the table, so drop it locally and undo
    // what addEmptyRow set. Re-fetching does not remove it when the journal has no saved milestones.
    removeUnsavedJournalMilestone = () => {
        this.setState({
            loadedData: this.state.loadedData.filter((row) => row.id !== ""),
            editedId: "-1",
            disableAddButton: false,
        });
    }

    deleteJournalMilestone = (id) => {
        var deleteApiController = this

        $.ajax({
            url: "/my-jeeva-api/delete-journal-milestone/" + id,

            method: "DELETE",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    deleteApiController.refreshData();
                    // deleteApiController.fetchJournalMilestones();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            },
        });
    }

    fetchJournalMilestones = () => {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/fetch-journal-milestones",
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                journalId: this.props.location.state.journalId,
            },
            success: function (res) {
                if (res.success === true) {
                    if (res.result.length > 0) {
                        thisController.fetchMileStones();
                        thisController.state.loadedData = res.result;
                        thisController.state.isLoading = false;
                        thisController.state.disableAddButton = false;
                        thisController.setState(thisController.state);
                    } else {
                        thisController.fetchMileStones();
                        thisController.state.isLoading = false;
                        thisController.state.noDataMessage = "There is no journal milestone scheduled."
                        thisController.setState(thisController.state);

                    }

                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            },
        });
    }


    refreshData = (e) => {
        // e.preventDefault();
        this.setState({
            disabled: false,
            editedId: "-1",
            isLoading: true,
            loadedData: [],
            // Clearing loadedData drops any unsaved "+" row, so "+" must be enabled again too.
            disableAddButton: false,

        });
        this.fetchJournalMilestones();
    };


    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Episode detail deleted successfully</b>, {
            position: "top-center",
        });
    }




    notifyFailedResponse(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    notifyEmptyMilestoneName(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Please select milestone</b>, {
            position: "top-center",
            color: "red"

        });
    }

    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }




    caseInsensitiveSort = (field) => (rowA, rowB) => {
        var a;
        var b;
        if (field === "milestoneStart" || field === "milestoneEnd") {
            a = rowA[field] ? rowA[field] : "";
            b = rowB[field] ? rowB[field] : "";

        } else {
            a = rowA[field] ? rowA[field].toLowerCase() : '';
            b = rowB[field] ? rowB[field].toLowerCase() : '';
        }
        if (a > b) {
            return 1;
        }

        if (b > a) {
            return -1;
        }

        return 0;
    };



    handleDropdownChange = (event) => {
        const selectedMilestoneName = event.target.value;
        const selectedMilestone = this.state.mileStones.find(
            (milestone) => milestone.mileStoneName === selectedMilestoneName
        );

        this.setState({
            selectedMilestoneId: selectedMilestone ? selectedMilestone.id : "",
            selectedMilestoneName,
        });
    };


    saveJournalMilestone = () => {
        var thisController = this;

        if (thisController.state.selectedMilestoneName == "") {
            thisController.notifyEmptyMilestoneName();
        } else if (thisController.minutesError()) {
            thisController.notifyFailedToUpdate(thisController.minutesError());
        } else {
            var journalMilestoneData = {
                journalId: this.props.location.state.journalId,
                milestoneName: thisController.state.selectedMilestoneName,
                milestoneId: thisController.state.selectedMilestoneId,
                milestoneStart: thisController.state.milestoneStart,
                milestoneEnd: thisController.state.milestoneEnd,
                offsetType: thisController.state.offsetType,
                hourOffset: thisController.offsetOrNull(thisController.state.hourOffset),
                minuteOffset: thisController.offsetOrNull(thisController.state.minuteOffset)
            }

            $.ajax({
                url: "/my-jeeva-api/save-journal-milestone",
                method: "POST",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(journalMilestoneData),

                success: function (res) {
                    if (res.success === true) {
                        thisController.fetchJournalMilestones();
                    } else {
                        thisController.notifyFailedToUpdate(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                },
            });
        }

    }

    updateJournalMilestone = (props) => {
        var thisController = this;
        if (thisController.minutesError()) {
            thisController.notifyFailedToUpdate(thisController.minutesError());
            return;
        }


        var journalMilestoneData = {
            id: props.id,
            journalId: this.props.location.state.journalId,
            milestoneName: thisController.state.selectedMilestoneName,
            milestoneId: thisController.state.selectedMilestoneId,
            milestoneStart: thisController.state.milestoneStart,
            milestoneEnd: thisController.state.milestoneEnd,
            offsetType: thisController.state.offsetType,
            hourOffset: thisController.offsetOrNull(thisController.state.hourOffset),
            minuteOffset: thisController.offsetOrNull(thisController.state.minuteOffset)
        }


        $.ajax({
            url: "/my-jeeva-api/update-journal-milestone",
            method: "PATCH",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json",
            },
            data: JSON.stringify(journalMilestoneData),

            success: function (res) {
                if (res.success === true) {
                    thisController.state.editedId = "-1";
                    thisController.fetchJournalMilestones();
                } else {
                    thisController.notifyFailedToUpdate(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            },
        });
    }

    /** Only floating time sends an offset; blank goes as null, which the server reads as 0. */
    offsetOrNull = (value) => {
        if (this.state.offsetType !== "FLOATING_TIME") return null;
        if (value === "" || value === null || value === undefined) return null;
        var number = parseInt(value, 10);
        return isNaN(number) ? null : number;
    }

    /**
     * Minutes carry only what is left over after the whole hours, so 90 is refused rather than
     * quietly turned into 1 hour 30 minutes - the nurse sees exactly what will be saved.
     */
    minutesError = () => {
        if (this.state.offsetType !== "FLOATING_TIME") return "";
        var minutes = parseInt(this.state.minuteOffset, 10);
        if (isNaN(minutes) || (minutes >= -59 && minutes <= 59)) return "";
        return "Minutes offset must be between -59 and 59. Use Hours offset for whole hours"
            + " (e.g. 90 minutes = 1 hour 30 minutes).";
    }

    /**
     * What the window means, worked against a patient milestone today at 14:00. Mirrors the
     * server's rule: the offset moves both ends, except a same-day window closes at 23:59.
     */
    windowPreview = () => {
        if (this.state.offsetType !== "FLOATING_TIME") return "";
        if (this.minutesError()) return this.minutesError();
        var toInt = (v) => { var n = parseInt(v, 10); return isNaN(n) ? null : n; };
        var first = toInt(this.state.milestoneStart);
        var last = toInt(this.state.milestoneEnd);
        var offset = (toInt(this.state.hourOffset) || 0) * 60 + (toInt(this.state.minuteOffset) || 0);
        var day = 24 * 60;
        var base = 14 * 60;
        var describe = (fromMidnight) => {
            var dayShift = Math.floor(fromMidnight / day);
            var minuteOfDay = ((fromMidnight % day) + day) % day;
            var hh = String(Math.floor(minuteOfDay / 60)).padStart(2, "0");
            var mm = String(minuteOfDay % 60).padStart(2, "0");
            return hh + ":" + mm + " " + this.dayPhrase(dayShift);
        };
        var opens = first === null ? null : first * day + base + offset;
        var closesText;
        if (last === null) {
            closesText = "never closes";
        } else if (first !== null && first === last) {
            var closeDay = Math.max(last, Math.floor(opens / day));
            closesText = "closes " + describe(closeDay * day + day - 1);
        } else {
            closesText = "closes " + describe(last * day + base + offset);
        }
        var opensText = opens === null ? "is open from the start" : "opens " + describe(opens);
        return "e.g. a patient milestone with today's date at 14:00 " + opensText + " and " + closesText;
    }

    dayPhrase = (days) => {
        if (days === 0) return "the same day";
        if (days === 1) return "the next day";
        if (days === -1) return "the day before";
        return days > 0 ? days + " days after" : Math.abs(days) + " days before";
    }

    handleOffsetTypeChange = (e) => {
        // Specific time does not use the offsets, so clear them rather than leave stale values
        // in greyed-out inputs. Only the edit state changes; the saved row is left alone.
        var floating = e.target.value === "FLOATING_TIME";
        this.setState({
            offsetType: e.target.value,
            hourOffset: floating ? this.state.hourOffset : "",
            minuteOffset: floating ? this.state.minuteOffset : "",
        });
    }

    handleHourOffsetChange = (e) => {
        this.setState({ hourOffset: e.target.value });
    }

    handleMinuteOffsetChange = (e) => {
        this.setState({ minuteOffset: e.target.value });
    }

    handleMilestoneStartChange = (e) => {
        this.state.milestoneStart = e.target.value;
        this.setState(this.state);
    }

    handleMilestoneEndChange = (e) => {
        this.state.milestoneEnd = e.target.value;
        this.setState(this.state);
    }

    goBackFromSubTab = () => {
        var pageNum = this.props.location.state.pageNum;
        this.props.history.push({
            pathname: "/projectmgmt/journal",
            state: {
                pageNum: pageNum,
            }
        });
    }

    render() {
        const { loadedData } = this.state;

        const milestone_column = [


            {
                name: <b>Name</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('milestoneName'),
                selector: (props) => (
                    <div name="name">
                        <div
                            className="textarea"
                            style={{
                                background: 'white',
                                height: '2.7em',
                                resize: 'none',
                                paddingLeft: '2px',
                                paddingTop: '6px',
                                width: '98%',
                                border: props.id === '' || props.id === this.state.editedId ? '1px solid #D2D4DC' : 'none',
                                borderRadius: props.id === '' ? '2px' : 'none',
                            }}
                        >
                            {props.id === this.state.editedId ? (
                                <select
                                    value={this.state.selectedMilestoneName}
                                    onChange={this.handleDropdownChange}
                                >
                                    <option value="" disabled hidden>
                                        Select a milestone
                                    </option>
                                    {this.state.mileStones &&
                                        this.state.mileStones.map((selectedMileStone, index) => (
                                            <option key={index} value={selectedMileStone.mileStoneName}>
                                                {selectedMileStone.mileStoneName}
                                            </option>
                                        ))}
                                </select>
                            ) : (
                                <span>{props.milestoneName || 'N/A'}</span>
                            )}
                        </div>
                    </div>
                ),
            },
            {
                name: <b>Offset type</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('offsetType'),
                selector: (props) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {props.id === this.state.editedId ? (
                            <select
                                value={this.state.offsetType}
                                onChange={this.handleOffsetTypeChange}
                            >
                                <option value="SPECIFIC_TIME">Date only</option>
                                <option value="FLOATING_TIME">Floating time</option>
                            </select>
                        ) : (
                            <span>{props.offsetType === "FLOATING_TIME" ? "Floating time" : "Date only"}</span>
                        )}
                    </div>
                ),
            },

            {
                name: <b>First day relative to the milestone</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('milestoneStart'),
                selector: (props) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {props.id === this.state.editedId ? (
                            <input
                                type='number'
                                value={this.state.milestoneStart}
                                onChange={this.handleMilestoneStartChange}
                            />
                        ) : (
                            <span>
                                {props.milestoneStart == null ? 0 : props.milestoneStart}
                            </span>

                        )}
                    </div>
                ),
            },

            {
                name: <b>Last day relative to the milestone</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('milestoneEnd'),
                selector: (props) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {props.id === this.state.editedId ? (
                            <input
                                type='number'
                                value={this.state.milestoneEnd}
                                onChange={this.handleMilestoneEndChange}
                            />
                        ) : (
                            <span>
                                {props.milestoneEnd == null ? 0 : props.milestoneEnd}
                            </span>

                        )}
                    </div>
                ),
            },

            {
                name: <b>Hours offset</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('hourOffset'),
                selector: (props) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {props.id === this.state.editedId ? (
                            <input
                                type='number'
                                disabled={this.state.offsetType !== "FLOATING_TIME"}
                                style={this.state.offsetType !== "FLOATING_TIME" ? disabledHourInput : undefined}
                                title={this.state.offsetType === "FLOATING_TIME"
                                    ? "Hours before (-) or after (+) the patient milestone's time"
                                    : "Only used by a floating time window"}
                                value={this.state.hourOffset}
                                onChange={this.handleHourOffsetChange}
                            />
                        ) : (
                            <span>{props.hourOffset == null ? 0 : props.hourOffset}</span>
                        )}
                    </div>
                ),
            },

            {
                name: <b>Minutes offset</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('minuteOffset'),
                selector: (props) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {props.id === this.state.editedId ? (
                            <input
                                type='number'
                                min='-59'
                                max='59'
                                disabled={this.state.offsetType !== "FLOATING_TIME"}
                                style={this.state.offsetType !== "FLOATING_TIME" ? disabledHourInput : undefined}
                                title={this.state.offsetType === "FLOATING_TIME"
                                    ? "-59 to 59, added after the hours"
                                    : "Only used by a floating time window"}
                                value={this.state.minuteOffset}
                                onChange={this.handleMinuteOffsetChange}
                            />
                        ) : (
                            <span>{props.minuteOffset == null ? 0 : props.minuteOffset}</span>
                        )}
                    </div>
                ),
            },

            {
                name: <b>Actions</b>,
                width: 20,
                selector: (props) => (
                    <div id="action">
                        <button style={{ backgroundColor: "#ffffff", border: "none", marginLeft: '-6px' }} 
                         disabled = {(this.userDetails["userRole"] === "PHYSICIAN" &&
                            JSON.parse(localStorage.getItem('user_details')).emailId !== this.props.location.state.createdByEmail)
                        }
                        >
                            <img className="img-responsive"
                                title={(props.id == "") ||
                                    (props.id == this.state.editedId) ? 'Save' : 'Edit'}
                                style={{ 
                                    marginTop: '6px', 
                                    backgroundColor : (this.userDetails["userRole"] === "PHYSICIAN" &&
                                        JSON.parse(localStorage.getItem('user_details')).emailId !== this.props.location.state.createdByEmail) ? "#282a6596" : "#282a65",
                                    borderRadius: '5px', 
                                    padding: '1px' }}
                                src={(props.id == "") ? this.saveImageSrc : ((props.id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    (props.id == "") ?
                                        this.saveJournalMilestone(props, e)
                                        :
                                        (props.id == this.state.editedId) ?
                                            this.updateJournalMilestone(props, e)

                                            : this.makeCelledit(props, e);
                                }}
                            />
                        </button>


                        <button style={{
                            backgroundColor: "#ffffff", border: "none", marginLeft: '-6px'
                        }} 
                        disabled = {(this.userDetails["userRole"] === "PHYSICIAN" &&
                            JSON.parse(localStorage.getItem('user_details')).emailId !== this.props.location.state.createdByEmail)}
                        title="Delete">
                            <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                                style={{ marginTop: '6px', 
                                    backgroundColor : (this.userDetails["userRole"] === "PHYSICIAN" &&
                                        JSON.parse(localStorage.getItem('user_details')).emailId !== this.props.location.state.createdByEmail) ? "#282a6596" : "#282a65",
                                    borderRadius: '5px', padding: '1px' }}
                                onClick={() => (props.id) === '' ?
                                    this.removeUnsavedJournalMilestone()
                                    :
                                    this.openDeletePopUp(props)
                                }

                            /></button>
                    </div>), width: 100
            },
        ]
        return (
            <div style={{ marginRight: '1%' }} id='painDataTab'>

                <div style={{ background: "#F9F9FB", overflowY: 'scroll', overflowX: 'hidden', height: '60vh' }} >
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />
                    <link rel="stylesheet" href="assets/css/painDataSchedule.css" />
                    <link rel="stylesheet" href="assets/css/DashBoardGraph.css" />


                    <div className="row" style={{ marginLeft: '14px' }}>

                        <div style={{ marginTop: '75px' }}  >
                            <img src="assets/images/arrow.svg"
                                style={{ paddingRight: "30%", cursor: 'pointer' }}
                                onClick={this.goBackFromSubTab}
                            />
                        </div>


                        <div className="patient-info-container"
                            style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "55vw" }}
                        >
                            <div className="patient-info-box">
                                <strong>Treatment Name</strong>
                                <p>{this.props.location.state.treatmentName}</p>
                            </div>

                            <div className="patient-info-box">
                                <strong> Journal Name</strong>
                                <p>{this.props.location.state.journalName}</p>
                            </div>


                        </div>
                        <div className="col-sm-3" style={{ marginTop: '45px' }}>
                            <div className="d-flex flex-row-reverse pt-2">

                                <div className="p-2" style={{ marginBottom: '10px' }}>

                                    <button className="btn action-button"
                                        id="addMsg" title=" Add "
                                        disabled = {(this.userDetails["userRole"] === "PHYSICIAN" &&
                                            JSON.parse(localStorage.getItem('user_details')).emailId !== this.props.location.state.createdByEmail)
                                        }
                                        onClick={this.state.disableAddButton ? this.notifyMsgFieldEmpty : this.addEmptyRow}>
                                        <img src="assets/images/add_white_24dp.png" />
                                    </button>
                                    <button title="Refresh" onClick={this.refreshData} type="button" className="btn action-button">
                                        <img src="./assets/images/refresh_white_24dp.png"></img></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{ textAlign: 'left' }}>
                        <h6 className="nav-item" style={{ color: '#282a65', marginTop: '2vh', marginLeft: "1vw" }}>
                            Select a milestone then enter the number of days before (-) and after (+) the milestone that the journal should be displayed to patients.  Leave blank for no start or end date.</h6>
                        <div className="col-lg-12 ">
                            <div className="card">
                                {/* The offset fields are disabled on a specific-time window and the
                                    reason is only in a tooltip, which is found by accident. */}
                                <div style={{
                                    fontSize: '10pt',
                                    color: '#444',
                                    background: '#f4f5fb',
                                    border: '1px solid #d7d8ea',
                                    borderRadius: '4px',
                                    padding: '8px 12px',
                                    margin: '10px'
                                }}>
                                    This page defines the date range a journal is available to patients
                                    relative to a treatment milestone. Journals are always displayed to
                                    patients by default unless availability is restricted on this page.
                                    <br />
                                    <b>Date only</b> displays journals for whole days relative to a
                                    patient's milestone date. The journal displays from 12:00 AM on the
                                    first day to 11:59 PM on the last day based on optional Day offsets.
                                    <b> Hours offset</b> and <b>Minutes offset</b> do not apply and are disabled.
                                    <br />
                                    <b>Floating time</b> displays journals relative to the patient-specific
                                    milestone time. Optional Day, hour, and minute offsets enable journal
                                    availability a specific time before (negative offset) or after
                                    (positive offset) a patient's milestone.
                                    <br />
                                    Journal notifications are only sent to patients if the journal is
                                    available to them.
                                </div>
                                {this.state.isLoading && (
                                    <div style={{ padding: '20px', textAlign: 'center' }}>
                                        <p>Loading ...</p>
                                    </div>
                                )}
                                {!this.state.isLoading && this.state.loadedData.length === 0 && (
                                    <div style={{ padding: '20px', textAlign: 'center' }}>
                                        <p>There is no journal milestone scheduled. </p>
                                    </div>
                                )}
                                {!this.state.isLoading && this.state.loadedData.length > 0 &&
                                    (<DataTable
                                        data={loadedData}
                                        columns={milestone_column}
                                        defaultPageSize={5}
                                        pageSizeOptions={[5, 10, 15]}
                                        onPageChange={this.onPageChange}
                                        pagination={this.state.paginationValue}
                                        noDataComponent={<this.CustomNoDataComponent />}
                                    />)}
                                {this.state.editedId !== "-1" && this.windowPreview() && (
                                    <div style={{
                                        fontSize: '10pt', padding: '4px 12px 10px',
                                        color: this.minutesError() ? '#c62828' : '#282a65',
                                    }}>
                                        {this.windowPreview()}
                                    </div>
                                )}
                            </div>
                            <ToastContainer className="Toast-at-center" />
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

export default JournalMilestone;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/JournalMilestone.js